"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enterprise = void 0;
var Enterprise = /** @class */ (function () {
    function Enterprise(json) {
        this.id = json.id;
        this.title = json.title;
        this.address = json.address;
        this.email = json.email;
        this.url = json.url;
        this.zip = json.zip;
        this.firstname = json.firstname;
        this.lastname = json.lastname;
        this.phone = json.phone;
        this.ifu = json.ifu;
        this.is_default = json.is_default;
        this.user_id = json.user_id;
        this.created_at = json.created_at;
    }
    Object.defineProperty(Enterprise.prototype, "summer", {
        get: function () {
            return "".concat(this.title, "(").concat(this.ifu, "), ").concat(this.firstname, ", ").concat(this.lastname);
        },
        enumerable: false,
        configurable: true
    });
    Enterprise.prototype.toJson = function () {
        return __assign({}, this);
    };
    return Enterprise;
}());
exports.Enterprise = Enterprise;
